var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "seo-search" },
    _vm._l(_vm.items, function (item, index) {
      return _c("li", { key: index }, [
        _c(
          "a",
          {
            attrs: {
              href: item.href,
              title: item.q,
              uigs: "out_query_" + index + "_" + item.q,
            },
          },
          [_vm._v(_vm._s(item.q))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }